import { Timeline, TimelineItem } from '@/components/base/Timeline'

interface MockOperationLog {
  id: string
  time: string
  description: string
}

const MOCK_OPERATION_LOGS: MockOperationLog[] = [
  { id: '1', time: '2024-08-02 06:28', description: 'Unbind ins-bod82yhd' },
  { id: '2', time: '2024-08-01 08:28', description: 'Bind ins-bod82yha' },
  { id: '3', time: '2024-07-23 16:34', description: 'Create Public IP' },
]

export function OperationLogContent() {
  return (
    <div className="bg-neutral-50 rounded-lg p-4">
      <Timeline>
        {MOCK_OPERATION_LOGS.map((log) => (
          <TimelineItem key={log.id}>
            <div className="flex items-center gap-4 py-3">
              <span className="t-xs text-secondary shrink-0">{log.time}</span>
              <span className="t-sb text-primary">{log.description}</span>
            </div>
          </TimelineItem>
        ))}
      </Timeline>
    </div>
  )
}
